import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { FilterLayout } from "../layout/FilterLayout";
import { Autocomplete, TextField ,FormControl} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Button from "../ui/Button";
import { getDepartments,getDesignations,getOfficeLocations } from "../../services/labourLaw";


const LabourLawFilter = ({ onFilter,onExport}) => {

  const getCurrentMonthDate = () => {
    const d = new Date();
    return new Date(d.getFullYear(), d.getMonth(), 1);
  };

  const timelyWagesOptions = [
    { label: "Paid", value: 1 },
    { label: "Unpaid", value: 0 },
  ]; 

  const healthCheckOptions = [
    { label: "Completed", value: 1 },
    { label: "Pending", value: 0 },
  ];

  const pfOptions = [
    { label: "Paying", value: 1 },
    { label: "Non-Paying", value: 0 },
  ];

  const esicOptions = [
    { label: "Paying", value: 1 },
    { label: "Non-Paying", value: 0 },
  ];

  const shiftHoursOptions = [
    { label: "Within Limit", value: 1 },
    { label: "Exceeded", value: 0 },
  ];

  const overtimeOptions = [
    { label: "Compliant", value: 1 },
    { label: "Non-Compliant", value: 0 },
  ];

  const basicCTCOptions = [
    { label: "Compliant", value: 1 },
    { label: "Non-Compliant", value: 0 },
  ];

  const skillLevelOptions = [
    { label: "Compliant", value: 1 },
    { label: "Non-Compliant", value: 0 },
  ];


  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      search: "",
      department: null,
      designation: null,
      office_location: null,
      month: getCurrentMonthDate(),
      timely_wages: null,
      health_check: null,
      pf: null,
      esic: null,
      shift_hours: null,
      overtime: null,
      basic_ctc: null,
      skill_level: null,
    },
  });

  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [officeLocations, setOfficeLocations] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [deptRes, desigRes, locRes] = await Promise.all([
          getDepartments(),
          getDesignations(),
          getOfficeLocations()
        ]);

        setDepartments((deptRes.data.data || []).map(d => ({
          label: d._DeptName,
          value: d._DeptID,
        })));

        setDesignations((desigRes.data.data || []).map(d => ({
          label: d._DesigName,
          value: d._DesigID,
        })));

        setOfficeLocations((locRes.data.data || []).map(d => ({
          label: d._LocationName,
          value: d._OfficeLocationId,
        })));

      } catch (error) {
        console.error("Error fetching filter data:", error);

        // fallback static options if API fails
        setDepartments([]);
        setDesignations([]);
        setOfficeLocations([]);
      }
    };

    fetchData();
    // eslint-disable-next-line
  }, []);


  const onSubmit = (data) => {
    const params = {};
    if (data.search) params.search = data.search.trim();
    if (data.department) params.department = data.department;
    if (data.designation) params.designation = data.designation;
    if (data.office_location) params.office_location = data.office_location;
    if (data.month) {
      params.month = data.month.getMonth() + 1; // 1–12
      params.year = data.month.getFullYear();   // YYYY
    }
    if (data.timely_wages !== null) params.timely_wages = data.timely_wages;
    if (data.health_check !== null) params.health_check = data.health_check;
    if (data.pf !== null) params.pf = data.pf;
    if (data.esic !== null) params.esic = data.esic;
    if (data.shift_hours !== null) params.shift_hours = data.shift_hours;
    if (data.overtime !== null) params.overtime = data.overtime;
    if (data.basic_ctc !== null) params.basic_ctc = data.basic_ctc;
    if (data.skill_level !== null) params.skill_level = data.skill_level;

    onFilter(params);
  };

  const handleClear = () => {
    reset({
      search: "",
      department: null,
      designation: null,
      office_location: null,
      month: getCurrentMonthDate(),
      timely_wages: null,
      health_check: null,
      pf: null,
      esic: null,
      shift_hours: null,
      overtime: null,
      basic_ctc: null,
      skill_level: null,
    });
    onFilter({
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear(),
    });
  };

  return (
    <FilterLayout>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">

          {/* Search */}
          <div className="col-md-3">
            <Controller
              name="search"
              control={control}
              render={({ field }) => (
                <TextField {...field} label="Emp Name / Code" size="small" fullWidth 
                  sx={{
                    backgroundColor: "white",
                  }}
                />
              )}
            />
          </div>

          {/* Department */}
          <div className="col-md-3">
            <Controller
              name="department"
              control={control}
              render={({ field }) => (
                <FormControl
                  fullWidth
                  size="small"
                  sx={{
                    backgroundColor: "white",
                  }}
                >
                  <Autocomplete
                    options={departments}
                    value={departments.find(o => o.value === field.value) || null}
                    onChange={(_, v) => field.onChange(v?.value || null)}
                    renderInput={(params) => <TextField {...params} label="Department" size="small" />}
                  />
                </FormControl>
              )}
            />
          </div>

          {/* Designation */}
          <div className="col-md-3">
            <Controller
              name="designation"
              control={control}
              render={({ field }) => (
                <FormControl
                  fullWidth
                  size="small"
                  sx={{
                    backgroundColor: "white",
                  }}
                >
                  <Autocomplete
                    options={designations}
                    value={designations.find(o => o.value === field.value) || null}
                    onChange={(_, v) => field.onChange(v?.value || null)}
                    renderInput={(params) => <TextField {...params} label="Designation" size="small" />}
                  />
                </FormControl>
              )}
            />
          </div>

          {/* Office Location */}
          <div className="col-md-3">
            <Controller
              name="office_location"
              control={control}
              render={({ field }) => (
                <FormControl
                  fullWidth
                  size="small"
                  sx={{
                    backgroundColor: "white",
                  }}
                >
                  <Autocomplete
                    options={officeLocations}
                    value={officeLocations.find(o => o.value === field.value) || null}
                    onChange={(_, v) => field.onChange(v?.value || null)}
                    renderInput={(params) => <TextField {...params} label="Office Location" size="small" />}
                  />
                </FormControl>
              )}
            />
          </div>

          {/* Month Picker */}
          <div className="col-md-3 mt-4">
            <Controller
              name="month"
              control={control}
              render={({ field }) => (
                <FormControl
                  fullWidth
                  size="small"
                  sx={{
                    backgroundColor: "white",
                  }}
                >
                  <DatePicker
                    {...field}
                    label="Month"
                    views={["year", "month"]} 
                    openTo="month"
                    format="MMM yyyy"
                    slotProps={{
                      textField: {
                        size: "small",
                        fullWidth: true,
                      },
                    }}
                  />
                </FormControl>
              )}
            />
          </div>

          {/* Timely Wages */}
          <div className="col-md-3 mt-3">
            <Controller
              name="timely_wages"
              control={control}
              render={({ field }) => (
                <FormControl
                  fullWidth
                  size="small"
                  sx={{
                    backgroundColor: "white",
                  }}
                >
                  <Autocomplete
                    options={timelyWagesOptions}
                    value={timelyWagesOptions.find(o => o.value === field.value) || null}
                    onChange={(_, v) => field.onChange(v?.value ?? null)}
                    renderInput={(params) => (
                      <TextField {...params} label="Timely Wages" size="small" />
                    )}
                  />
                </FormControl>
              )}
            />
          </div>

          {/* Health Check */}
          <div className="col-md-3 mt-3">
            <Controller
              name="health_check"
              control={control}
              render={({ field }) => (
                <FormControl
                  fullWidth
                  size="small"
                  sx={{
                    backgroundColor: "white",
                  }}
                >
                  <Autocomplete
                    options={healthCheckOptions}
                    value={healthCheckOptions.find(o => o.value === field.value) || null}
                    onChange={(_, v) => field.onChange(v?.value ?? null)}
                    renderInput={(params) => (
                      <TextField {...params} label="Health Check" size="small" />
                    )}
                  />
                </FormControl>
              )}
            />
          </div>

          {/* PF  */}
          <div className="col-md-3 mt-3">
            <Controller
              name="pf"
              control={control}
              render={({ field }) => (
                <FormControl
                  fullWidth
                  size="small"
                  sx={{
                    backgroundColor: "white",
                  }}
                >
                  <Autocomplete
                    options={pfOptions}
                    value={pfOptions.find(o => o.value === field.value) || null}
                    onChange={(_, v) => field.onChange(v?.value ?? null)}
                    renderInput={(params) => (
                      <TextField {...params} label="PF" size="small" />
                    )}
                  />
                </FormControl>
              )}
            />
          </div>

           {/*  ESIC */}
          <div className="col-md-3 mt-3">
            <Controller
              name="esic"
              control={control}
              render={({ field }) => (
                <FormControl
                  fullWidth
                  size="small"
                  sx={{
                    backgroundColor: "white",
                  }}
                >
                  <Autocomplete
                    options={esicOptions}
                    value={esicOptions.find(o => o.value === field.value) || null}
                    onChange={(_, v) => field.onChange(v?.value ?? null)}
                    renderInput={(params) => (
                      <TextField {...params} label="ESIC" size="small" />
                    )}
                  />
                </FormControl>
              )}
            />
          </div>

          {/* Shift Hours */}
          <div className="col-md-3 mt-3">
            <Controller
              name="shift_hours"
              control={control}
              render={({ field }) => (
                <FormControl
                  fullWidth
                  size="small"
                  sx={{
                    backgroundColor: "white",
                  }}
                >
                  <Autocomplete
                    options={shiftHoursOptions}
                    value={shiftHoursOptions.find(o => o.value === field.value) || null}
                    onChange={(_, v) => field.onChange(v?.value ?? null)}
                    renderInput={(params) => (
                      <TextField {...params} label="Shift Hours" size="small" />
                    )}
                  />
                </FormControl>
              )}
            />
          </div>

          {/* Overtime */}
          <div className="col-md-3 mt-3">
            <Controller
              name="overtime"
              control={control}
              render={({ field }) => (
                <FormControl
                  fullWidth
                  size="small"
                  sx={{
                    backgroundColor: "white",
                  }}
                >
                  <Autocomplete
                    options={overtimeOptions}
                    value={overtimeOptions.find(o => o.value === field.value) || null}
                    onChange={(_, v) => field.onChange(v?.value ?? null)}
                    renderInput={(params) => (
                      <TextField {...params} label="Overtime" size="small" />
                    )}
                  />
                </FormControl>
              )}
            />
          </div>

          {/* Basic CTC */}
          <div className="col-md-3 mt-3">
            <Controller
              name="basic_ctc"
              control={control}
              render={({ field }) => (
                <FormControl
                  fullWidth
                  size="small"
                  sx={{
                    backgroundColor: "white",
                  }}
                >
                  <Autocomplete
                    options={basicCTCOptions}
                    value={basicCTCOptions.find(o => o.value === field.value) || null}
                    onChange={(_, v) => field.onChange(v?.value ?? null)}
                    renderInput={(params) => (
                      <TextField {...params} label="Basic CTC" size="small" />
                    )}
                  />
                </FormControl>
              )}
            />
          </div>

          {/* Overtime */}
          <div className="col-md-3 mt-3">
            <Controller
              name="skill_level"
              control={control}
              render={({ field }) => (
                <FormControl
                  fullWidth
                  size="small"
                  sx={{
                    backgroundColor: "white",
                  }}
                >
                  <Autocomplete
                    options={skillLevelOptions}
                    value={skillLevelOptions.find(o => o.value === field.value) || null}
                    onChange={(_, v) => field.onChange(v?.value ?? null)}
                    renderInput={(params) => (
                      <TextField {...params} label="Skill Level Wages" size="small" />
                    )}
                  />
                </FormControl>
              )}
            />
          </div>


          {/* Buttons */}
          <div className="col-md-3 mt-3">
            <Button type="submit" variant="success">Filter</Button>
            <Button type="button" variant="dark" onClick={handleClear} style={{ marginLeft: 5 }}>Clear</Button>
            <Button type="button" variant="success" style={{ marginLeft: 5 }} onClick={onExport} >Export</Button>
          </div>

        </div>
      </form>
    </FilterLayout>
  );
};

export default LabourLawFilter;
